import {typeFromValidation} from '../../helpers/typescript/typeHelpers';

/** All in-product announcement identifiers we've ever used, to ensure global uniqueness. */
export const enum AnnouncementIdsEnum {
  INTERNAL_AI_ANSWERS = 'internalAiAnswers',
  RULE_TESTER_AT_CREATION = 'ruleTesterAtCreation',
  RULE_TESTER_AT_EDITION = 'ruleTesterAtEdition',
  RULE_LIST_RESOLUTION_TIME_SLA = 'ruleListResolutionTimeSla',
  AI_ASSIST = 'aiAssist',
  AI_ASSIST_EXTERNAL_KNOWLEDGE_SOURCE = 'aiAssistExternalKnowledgeSource',
  AI_AUTOPILOT = 'aiAutopilot',
  AI_TERMS = 'aiTerms',
  RINGCENTRAL_RELEASE = 'ringCentralRelease',
  INBOX_REDESIGN = 'inboxRedesign',
  INBOX_REDESIGN_GA = 'inboxRedesignGa',
  INBOX_REDESIGN_FORCE_ENABLE = 'inboxRedesignForceEnable',
  SUPPORT_AT_SCALE = 'supportAtScale',
  MULTI_REQUEST_CONNECTORS = 'multiRequestConnectors',
  WORKFORCE_MANAGEMENT = 'workforceManagement',
  SLACK_CHANNEL_USER_AUTH_ANNOUNCEMENT = 'slackChannelUserAuthAnnouncement',
  SLACK_RELEASE = 'slackRelease',
  SLACK_INBOXES_TIP = 'slackInboxesTip',
  SLACK_MENTIONS = 'slackMentions',
  FLOWCHART_RULE = 'flowchartRule',

  INBOX_REDESIGN_REMINDER_1 = 'inboxRedesignReminder1',
  INBOX_REDESIGN_REMINDER_2 = 'inboxRedesignReminder2',
  INBOX_REDESIGN_REMINDER_3 = 'inboxRedesignReminder3',
  INBOX_REDESIGN_REMINDER_4 = 'inboxRedesignReminder4',
  INBOX_REDESIGN_REMINDER_5 = 'inboxRedesignReminder5',
  INBOX_IMPROVEMENTS_LAUNCH = 'inboxImprovementsLaunch',
  FRONT_UNWRAPPED = 'frontUnwrapped',
  INBOX_IMPROVEMENTS_HEADER_EXPAND_TIP = 'inboxImprovementsHeaderExpandTip',
}

export type UserSurveyAnnouncementId = `userSurvey-${string}`;

export const RUserSurveyAnnouncementId = typeFromValidation(
  'UserSurveyAnnouncementId',
  (value): value is UserSurveyAnnouncementId => typeof value === 'string' && value.startsWith('userSurvey-'),
);

export type AnnouncementId = AnnouncementIdsEnum | UserSurveyAnnouncementId;
